import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { getSslcommerzCallbackUrl } from '../utils/UrlUtilities';

/**
 * DEV-ONLY mimic of the SSLCommerz hosted payment page. The real gateway isn't wired
 * yet (PAYMENTS_GATEWAY_STUB=true); `initiate` redirects here. Each button submits a
 * POST form to the backend callback — exactly how SSLCommerz POSTs the browser back —
 * so the whole finalize→grant→result flow is exercised. Unused once the real gateway lands.
 */
export default function MockGateway() {
    const [params] = useSearchParams();
    const tranId = params.get('tran_id') || '';
    const amount = params.get('amount') || '';

    const Form = ({ kind, label, className }) => (
        <form method="POST" action={getSslcommerzCallbackUrl(kind)} className="d-inline">
            <input type="hidden" name="tran_id" value={tranId} />
            <input type="hidden" name="val_id" value={`MOCK-${tranId}`} />
            <input type="hidden" name="status" value={kind === 'success' ? 'VALID' : 'FAILED'} />
            <button type="submit" className={className}>{label}</button>
        </form>
    );

    return (
        <div className="container py-5" style={{ maxWidth: 480 }}>
            <div className="card shadow-sm">
                <div className="card-header text-center fw-bold" style={{ background: '#fef3c7', color: '#92400e' }}>
                    ⚠ Simulated payment gateway (SSLCommerz not yet integrated)
                </div>
                <div className="card-body text-center">
                    <p className="mb-1 text-muted">Transaction</p>
                    <p className="fw-semibold">{tranId}</p>
                    <p className="mb-1 text-muted">Amount</p>
                    <h3 className="mb-4" style={{ color: '#4c1d95' }}>৳{amount}</h3>
                    <div className="d-flex flex-column gap-2">
                        <Form kind="success" label="Pay Now (simulate success)" className="btn btn-success w-100" />
                        <Form kind="fail" label="Simulate failure" className="btn btn-outline-danger w-100" />
                        <Form kind="cancel" label="Cancel" className="btn btn-outline-secondary w-100" />
                    </div>
                </div>
            </div>
        </div>
    );
}
